export default /* glsl */ `vec2 screenPassUV(vec4 uvwo, vec4 stpq) {
  return uvwo.xy;
}
`;
